module.exports = __webpack_public_path__ + "img/case_9.e01d05ab.png";